import DecisionTable from './DecisionTable';

export default DecisionTable;
